import React from 'react';

const Hero = ({ about }) => {
  return (
    <section className="relative overflow-hidden bg-dark-900 pt-28 pb-16">
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-primary-500/40 to-transparent"></div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:items-center">
          <div>
            <h1 className="max-w-4xl text-4xl font-bold tracking-tight text-white sm:text-5xl lg:text-6xl">
              {about?.name || 'Fraser FJ'}
            </h1>

            <h2 className="mt-5 text-xl font-semibold text-primary-300 sm:text-2xl">
              {about?.title || 'Cloud & DevOps Engineer'}
            </h2>

            <p className="mt-6 max-w-3xl text-lg leading-8 text-gray-300">
              {about?.summary ||
                'I work across AWS infrastructure, cloud security, and delivery automation, building practical systems that are reliable, maintainable, and secure by design.'}
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={about?.linkedin || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-md bg-[#0A66C2] px-4 py-2 font-semibold text-white transition-colors hover:bg-[#084f96] focus:outline-none focus:ring-2 focus:ring-[#0A66C2]/60"
              >
                <svg className="mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M20.45 20.45h-3.55v-5.57c0-1.33-.03-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.13 2.06 2.06 0 0 1 0 4.13zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.73V1.73C24 .77 23.2 0 22.23 0z" />
                </svg>
                LinkedIn
              </a>
              {about?.youtube && (
                <a
                  href={about.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center rounded-md bg-[#FF0000] px-4 py-2 font-semibold text-white transition-colors hover:bg-[#CC0000] focus:outline-none focus:ring-2 focus:ring-[#FF0000]/60"
                >
                  <svg className="mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.5 3.6 12 3.6 12 3.6s-7.5 0-9.4.5A3 3 0 0 0 .5 6.2C0 8.1 0 12 0 12s0 3.9.5 5.8a3 3 0 0 0 2.1 2.1c1.9.5 9.4.5 9.4.5s7.5 0 9.4-.5a3 3 0 0 0 2.1-2.1c.5-1.9.5-5.8.5-5.8s0-3.9-.5-5.8zM9.6 15.6V8.4l6.2 3.6-6.2 3.6z" />
                  </svg>
                  YouTube Channel
                </a>
              )}
              <a
                href={about?.github || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center rounded-md border border-gray-700 bg-[#24292F] px-4 py-2 font-semibold text-white transition-colors hover:bg-[#111827] focus:outline-none focus:ring-2 focus:ring-gray-500/60"
              >
                <svg className="mr-2 h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12 2C6.48 2 2 6.48 2 12.02c0 4.42 2.87 8.17 6.84 9.5.5.09.68-.22.68-.48 0-.24-.01-1.03-.01-1.87-2.51.46-3.16-.61-3.36-1.17-.11-.29-.6-1.17-1.03-1.41-.35-.19-.85-.66-.01-.67.79-.01 1.35.73 1.54 1.03.9 1.51 2.33 1.08 2.9.82.09-.65.35-1.08.64-1.33-2.22-.25-4.55-1.11-4.55-4.94 0-1.09.39-1.99 1.03-2.69-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.03A9.56 9.56 0 0 1 12 6.84c.85 0 1.7.11 2.5.34 1.91-1.3 2.75-1.03 2.75-1.03.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.69 0 3.84-2.34 4.69-4.57 4.94.36.31.68.91.68 1.85 0 1.33-.01 2.41-.01 2.74 0 .27.18.58.69.48A10.02 10.02 0 0 0 22 12.02C22 6.48 17.52 2 12 2z" clipRule="evenodd" />
                </svg>
                GitHub
              </a>
            </div>

          </div>

          {about?.youtube_latest_embed && (
            <div className="overflow-hidden rounded-lg border border-dark-600 bg-dark-800 shadow-lg">
              <div className="aspect-video">
                <iframe
                  className="h-full w-full"
                  src={about.youtube_latest_embed}
                  title="Latest FraseLabs YouTube video"
                  loading="lazy"
                  allow="fullscreen; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
